import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7200b995"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fixed-search-list"
};
const _hoisted_2 = {
  class: "page-name"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-back"
}, null, -1));
const _hoisted_4 = {
  class: "rout-title"
};
const _hoisted_5 = {
  key: 0,
  style: {
    "color": "red"
  }
};
const _hoisted_6 = {
  style: {
    "font-size": "14px",
    "color": "#a6a9ad"
  }
};
const _hoisted_7 = {
  class: "page-name-right"
};
const _hoisted_8 = {
  key: 0,
  class: "route-border"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.to ? (_openBlock(), _createBlock(_component_router_link, {
    key: 0,
    class: "toBack",
    to: _ctx.to
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tooltip, {
      class: "item",
      effect: "dark",
      content: _ctx.$t('ops-back'),
      placement: "bottom"
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }, 8, ["content"])]),
    _: 1
  }, 8, ["to"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_ctx.showRedStar ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*")) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(_ctx.$props.title || _ctx.$route.meta.title), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.subtitle), 1)]), _createElementVNode("div", _hoisted_7, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)])]), _ctx.showBottomBorder ? (_openBlock(), _createElementBlock("div", _hoisted_8)) : _createCommentVNode("", true)]);
}